import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        language: sessionStorage.getItem('locale') || 'en', // 默认语言为英文
    },
    mutations: {
        SET_LANGUAGE(state, language) {
            state.language = language;
            sessionStorage.setItem('locale', language);
        },
    },
    actions: {
        setLanguage({ commit }, language) {
            commit('SET_LANGUAGE', language);
        },
    },
});
